"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const BasePage_1 = require("../base/BasePage");
const PropertyDashboard_1 = require("./PropertyDashboard");
const helpers_1 = require("../../../hooks/helpers");
const react_redux_1 = require("react-redux");
const __1 = require("../../..");
const capability_1 = require("../../../util/capability");
const types_1 = require("../../../types");
const useCopyContext_1 = __importDefault(require("../../../hooks/useCopyContext"));
const TaskHeader_1 = require("../../components/task-header/TaskHeader");
const OnboardingModal_1 = require("../../components/onboarding-modal/OnboardingModal");
exports.default = (props) => {
    const property = (0, react_redux_1.useSelector)((state) => (0, helpers_1.hydratedPropertySelector)(state, props.propertyId));
    const customer = (0, react_redux_1.useSelector)((state) => state.data.customers.byId[props.customerId]);
    const pricing = (0, react_redux_1.useSelector)((state) => state.data.pricingUi.byPropertyId[props.propertyId]);
    const { capabilities } = React.useContext(__1.AppContext);
    const copyContext = (0, useCopyContext_1.default)();
    const headerNavCap = (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.HeaderNavigation);
    // Portal's property list route:
    // https://github.com/TravelNest/portal/blob/27aca81b4b87d70b3119d0ea5bd67e9a5f36cbd0/src/main.tsx#L162
    const headerNavProps = headerNavCap ? { backLinkTo: '/properties', subtitle: 'Properties' } : { noBackLink: true };
    const header = React.createElement(TaskHeader_1.Header, Object.assign({ title: copyContext.onboard ? 'Complete your first property' :
            copyContext.add ? 'Add a new property' :
                property.internal_name }, headerNavProps));
    return React.createElement(BasePage_1.BasePage, { header: header },
        React.createElement(OnboardingModal_1.OnboardingModal, { propertyId: props.propertyId }),
        React.createElement(PropertyDashboard_1.PropertyDashboard, { property: property, customer: customer, capabilities: capabilities, pricing: pricing }));
};
//# sourceMappingURL=PropertyDashboardPage.js.map